function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M38.51,18.44a3,3,0,1,0-3-3,3,3,0,0,0,3,3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M19.44,18.44a3,3,0,1,0-3-3,3,3,0,0,0,3,3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M29.2,36,24.06,47.52h5.06L39.85,21.43H34.93l-5.51,14-5.81-14H18.25l7.51,17c.45,1,2.55-1.05,3.44-2.39"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M41.71,34.7V21.43h5.22V33.65c0,3.28,1.19,4.63,3.72,4.63a4.7,4.7,0,0,0,4.92-4.93V21.43h5.21V42H55.57V37.68c-1,1.94-3,4.92-6.56,4.92-4,0-7.3-2.54-7.3-7.9"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M63.91,21.43h5.21v3.72a6.61,6.61,0,0,1,6.26-4A5.7,5.7,0,0,1,81,25a8.17,8.17,0,0,1,7-3.88c3.88,0,7.16,2.09,7.16,8.05V42H90V29.48c0-3.13-1-4.47-3.43-4.47s-4.17,1.64-4.17,4.77V42H77.17V29.48c0-3.13-1.34-4.47-3.58-4.47a4.39,4.39,0,0,0-4.47,4.77V42H63.91Z"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 98.03,
  y: 21.43,
  width: 5.21,
  height: 20.58
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M100.56,18.44a3,3,0,1,0-3-3,3,3,0,0,0,3,3"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    viewBox: "0 0 120 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.e94bbfb7.svg";
export { ForwardRef as ReactComponent };